import type { TranslationKey } from '@/i18n/translation-key';

/** i18n suffix: `media.settings.confirm.<section>.<field>.<direction>` */
export type MediaSettingsConfirmKey =
  | 'hosts.allowSelfCreate.off'
  | 'hosts.allowReorder.off'
  | 'hosts.allowFlowOverride.off'
  | 'hosts.allowScopeOverride.off'
  | 'speakers.allowFlowOverride.off'
  | 'speakers.allowSessionOverride.off'
  | 'flow.allowSessionOverride.off'
  | 'virtualMedia.allowFlowOverride.off'
  | 'virtualMedia.allowSessionOverride.off'
  | 'sessionTypes.offered.off'
  | 'sessionTypes.allowSelfCreate.off'
  | 'sessionTypes.allowReorder.off';

export function mediaSettingsConfirmMessageKey(key: MediaSettingsConfirmKey): TranslationKey {
  const [section, field, direction] = key.split('.') as [string, string, string];
  return `media.settings.confirm.${section}.${field}.${direction}` as TranslationKey;
}
